export const toolsName = {
    NMAP: 'NMAP',
    GITHUB_CODE_SCAN: 'Github Code Scan',
    BANDIT: 'Bandit',
    BLACKDUCK_HUB: 'Blackduck Hub',
    CHECKMARX: 'Checkmarx',
    COVERITY: 'Coverity',
    DEPENDENCY_CHECK: 'Dependency Check',
    FORTIFY: 'Fortify',
    HACKERONE: 'HackerOne',
    NESSUS: 'Nessus',
    NOWSECURE: 'Now Secure',
    ZAP: 'ZAP',
    SONARQUBE: 'SonarQube',
    SONARCLOUD: 'Sonarcloud',
    QUALYS_WEBAPP: 'Qualys WebApp',
    "QUALYS WEBAPP": 'Qualys WebApp',
    ACUNETIX: 'Acunetix',
    APPSCAN: 'AppScan',
    METASPLOIT: 'Metasploit',
    AQUA: 'Aqua',
    AWS_SECURITY_HUB: 'AWS Security Hub',
    BUGCROWD: 'Bugcrowd',
    GITLEAKS: 'Gitleaks',
    NIKTO: 'Nikto',
    SNYK: 'Snyk',
    PRISMA_CLOUD_TWISTLOCK: 'Prisma Cloud Twistlock',
    VERACODE: 'Veracode',
    DETECT_SECRETS: 'Detect Secrets',
    DEPENDENCY_TRACK: 'Dependency Track',
    CYCLONEDX: 'CycloneDX',
    "CYCLONE DX": 'CycloneDX',
    RAPID7_NEXPOSE: 'Rapid7 Nexpose',
    DEPENDABOT: 'Dependabot',
    QWIET_AI: 'Qwiet AI',
    BURPSUITE: 'Burpsuite',
    JFROG_XRAY: 'JFrog Xray',
    QUALYS_INFRASTRUCTURE: 'Qualys Infrastructure ',
    WEBINSPECT: 'Web Inspect',
    MEND: 'mend',
    SQREEN: 'Sqreen',
    TRUSTWAVE: 'Trustwave',
    OPENVAS_CSV: 'Openvas CSV',
    MOZILLA_OBSERVATORY: 'Mozilla Observatory',
    NETSPARKER: 'Netsparker',
    COBALT: 'Cobalt',
    BRAKEMAN: 'Brakeman',
    AWS_PROWLER: 'AWS Prowler',
    APPSPIDER: 'AppSpider',
    CLAIR: 'Clair',
    GOSEC_SCANNER: 'Gosec Scanner',
    ESLINT: 'ESLint',
    CONTRAST_SECURITY: 'Contrast Security',
    PRISMA_CLOUD_REDLOCK: 'Prisma Cloud Redlock',
    GOOGLE_CLOUD_REGISTRY:'Google Cloud Registry',
    GOOGLE_SECURITY_COMMAND_CENTER: 'Google Security Command Center',
    AVOCADO: 'Avocado',
    LACEWORK: "Lacework",
    SONATYPE_LIFECYCLE:"Sonatype Lifecycle",
    MAGENTO:"Magento",
    RAPID7_INSIGHT: "Rapid7 Insight",
    KICS:"Kics",
    BRIDGECREW:"Bridgecrew",
    SECURITYSCORECARD:"SecurityScorecard",
    AMAZON_GUARDDUTY: "Amazon GuardDuty",
    BURPSUITE_ENTERPRISE:"Burpsuite Enterprise",
    ORCA_SECURITY:"Orca Security",
    EDGESCAN:"Edgescan",
    NODEZERO:"Node Zero",
    WHITEHATSENTINEL:"WhiteHat Sentinel",
    APPKNOX:"Appknox",
    RAPID7_INSIGHTVM:"Rapid7 InsightVM",
    TANIUM:"Tanium",
    SALT_SECURITY: "Salt Security",
    GRAMMATECH:"Grammatech",
    SONRAI_SECURITY:"Sonrai Security",
    GRAMMATECH_CODESENTRY: "Grammatech - CodeSentry",
    CROWDSTRIKE_FALCON: "CrowdStrike Falcon",
    RAPID7_INSIGHT_CLOUD_SECURITY: "Rapid7 Insight Cloud Security",
    HCL_APPSCAN_CLOUD: "HCL AppScan on Cloud",
}
